"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CompositionAsset_1 = require("./CompositionAsset");
var ImageAsset_1 = require("./ImageAsset");
var AssetFactoryImpl = (function () {
    function AssetFactoryImpl() {
        var _this = this;
        this.constructAssetFromRawData = function (rawAssetData, version) {
            if (rawAssetData.layers) {
                return new CompositionAsset_1.CompositionAsset(rawAssetData, version);
            }
            else if (rawAssetData.w) {
                return new ImageAsset_1.ImageAsset(rawAssetData, version);
            }
            else {
                throw new Error("I don't know how to construct an asset from data: " + JSON.stringify(rawAssetData));
            }
        };
        this.clone = function (asset) {
            return _this.constructAssetFromRawData(asset.toRawData(), asset.rawDataVersion);
        };
    }
    return AssetFactoryImpl;
}());
exports.AssetFactory = new AssetFactoryImpl();
//# sourceMappingURL=AssetFactory.js.map